'use client';
import { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';

const CHAR_LIMIT = 320;

const autoGenerateDescription = (title) => {
    if (!title) return null;
    const words = title.toLowerCase();
    const isCamera = words.includes('camera') || words.includes('tripod') || words.includes('dslr');
    const isElectronic = words.includes('charger') || words.includes('cable') || words.includes('adapter') || words.includes('hub');
    const isAudio = words.includes('headphone') || words.includes('earphone') || words.includes('speaker') || words.includes('mic');
    let useCase = 'everyday use';
    if (isCamera) useCase = 'photography and videography';
    else if (isAudio) useCase = 'immersive audio experiences';
    else if (isElectronic) useCase = 'seamless connectivity';
    return `<strong>${title}</strong> is a premium quality product engineered for ${useCase}. Built with durable materials and precision craftsmanship, it delivers reliable performance to meet your needs. Ideal for both professionals and enthusiasts looking for quality and value.`;
};

export const DescriptionExpand = ({ description, title, coverImage, avgRating = 0 }) => {
    const [open, setOpen] = useState(false);

    const effectiveDescription = description || autoGenerateDescription(title);
    if (!effectiveDescription) return null;

    const stripped  = effectiveDescription.replace(/<[^>]*>/g, '');
    const isLong    = stripped.length > CHAR_LIMIT;
    const truncated = isLong
        ? effectiveDescription.substring(0, effectiveDescription.indexOf(' ', CHAR_LIMIT)) || effectiveDescription.substring(0, CHAR_LIMIT)
        : effectiveDescription;

    return (
        <>
            {/* ── Description text ── */}
            <div className="-mt-2">
                <h2
                    className="text-xs m-0 text-700 mb-0"
                    dangerouslySetInnerHTML={{ __html: truncated + (isLong ? '…' : '') }}
                />
                
                {isLong && (
                    <button
                    className ="mb-3 -mt-8"
                        onClick={() => setOpen(true)}
                        style={{
                            marginTop: '6px',
                            background: 'none', border: 'none', padding: 0,
                            cursor: 'pointer',
                            fontSize: '0.78rem', fontWeight: 700,
                            color: 'var(--primary-color)',
                            display: 'inline-flex', alignItems: 'center', gap: '4px',
                            textDecoration: 'underline dotted',
                        }}
                    >
                        Read More
                        <i className="pi pi-angle-down" style={{ fontSize: '0.7rem' }} />
                    </button>
                )}
            </div>

            {/* ── Full description sidebar ── */}
            <Sidebar
                visible={open}
                onHide={() => setOpen(false)}
                position="right"
                style={{ width: '480px', maxWidth: '96vw' }}
                pt={{
                    header:  { style: { padding: 0 } },
                    content: { style: { padding: 0, overflowY: 'auto' } },
                }}
                header={
                    <div style={{
                        background: 'var(--primary-color)',
                        padding: '1rem 1.2rem', width: '100%',
                        display: 'flex', alignItems: 'center', gap: '0.75rem',
                    }}>
                        {/* Product image */}
                        {coverImage ? (
                            <div style={{
                                width: 48, height: 48, borderRadius: '10px', flexShrink: 0,
                                background: '#fff', overflow: 'hidden', padding: '3px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            }}>
                                {/* eslint-disable-next-line @next/next/no-img-element */}
                                <img src={coverImage} alt={title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            </div>
                        ) : (
                            <div style={{
                                width: 48, height: 48, borderRadius: '10px', flexShrink: 0,
                                background: 'rgba(255,255,255,0.15)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <i className="pi pi-box" style={{ color: '#fff', fontSize: '1.2rem' }} />
                            </div>
                        )}

                        {/* Title + label */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.68rem', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                                Product Description
                            </div>
                            <div style={{
                                color: '#fff', fontWeight: 700, fontSize: '0.88rem', lineHeight: 1.3,
                                display: '-webkit-box', WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical', overflow: 'hidden',
                            }}>
                                {title}
                            </div>
                            {avgRating > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '3px', marginTop: '4px' }}>
                                    {[1,2,3,4,5].map(s => (
                                        <i key={s}
                                            className={`pi ${s <= Math.round(avgRating) ? 'pi-star-fill' : 'pi-star'}`}
                                            style={{ fontSize: '0.55rem', color: s <= Math.round(avgRating) ? '#fbbf24' : 'rgba(255,255,255,0.3)' }}
                                        />
                                    ))}
                                    <span style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.75)', marginLeft: '3px', fontWeight: 600 }}>
                                        {Number(avgRating).toFixed(1)}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                }
            >
                <div style={{ padding: '1.25rem 1.2rem' }}>
                    <div
                        className="text-xs"
                        style={{ color: '#334155', lineHeight: 1.75 }}
                        dangerouslySetInnerHTML={{ __html: effectiveDescription }}
                    />
                </div>
            </Sidebar>
        </>
    );
};
